<template>
  <div id="nescss">
    <div class="container">
      
      <h6>Doggy NFT Minted: {{ nftminted }}</h6>
      <h6>Doggy Token Supply: {{ tokensupply }}</h6>
      <h6>You are visitor number: {{ visitor_count }}</h6>
      <h3 style="padding-bottom: 15px">
        <router-link to="/dex">Try The Full Dex Search!</router-link>
      </h3>

      <div class="nes-field is-inline">
        <label for="NFT">NFT ID</label>
        <input
          v-model="enterID"
          type="number"
          id="NFT"
          class="nes-input is-success"
          placeholder="Please enter NFT ID"
          min="0"
          max="9999"
        />
        <button class="nes-btn is-primary" @click="getDoggyAttributes(enterID)">
          Submit
        </button>
      </div>
      <main class="main-content" ref="printMe">
        <section class="showcase">
          <section class="nes-container with-title">
            <h3 class="title">Doggy #{{ dognftid }}</h3>
            <div class="nes-table-responsive">
              <img
                :alt="dognftid"
                width="256"
                height="256"
                :src="dogimg"
                style="margin-bottom: 10px"
              />
              <table class="nes-table is-bordered is-centered tab">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(vals, name, index) in dog" :key="index">
                    <td style="text-transform: capitalize">{{ name }}</td>
                    <td style="text-transform: capitalize">{{ vals }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </section>
      </main>
      <main class="main-content">
        <section class="showcase">
          <section class="nes-container with-title">
            <h3 class="title">Basic Stats</h3>
            <h6>Click on the name to see further details!</h6>
            <div class="nes-table-responsive">
              <table class="nes-table is-bordered is-centered tab">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Count</th>
                    <th>Image</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(vals, name, index) in basicStats" :key="index">
                    <td>{{ name }}</td>
                    <td>{{ vals[0] }}</td>
                    <td>
                      <img
                        :src="vals[1]"
                        width="48"
                        height="48"
                        class="pixelated"
                        style="background: #8e6fb6"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </section>
      </main>
      <main class="main-content">
        <section class="showcase">
          <section class="nes-container with-title">
            <h3 class="title">Rarity Stats</h3>
            <div class="nes-table-responsive">
              <table class="nes-table is-bordered is-centered tab">
                <thead>
                  <tr>
                    <th>Collectible Value</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(vals, name, index) in rarityStats" :key="index">
                    <td>{{ vals[0] }}</td>
                    <td>{{ vals[1] }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </section>
      </main>
      <section class="icon-list">
        <h1>On Sale</h1>
        <h3>{{ saleCount }} NFTs</h3>
        <label for="default_select">Select number of Doggys per page</label>
        <div class="nes-select" style="padding-bottom: 15px">
          <select
            v-model="maxPerPage"
            @click="getDoggy(0)"
            @change="getDoggy(0)"
            required
            id="default_select"
          >
            <option value="50">50</option>
            <option value="75">75</option>
            <option value="100">100</option>
            <option value="150">150</option>
            <option value="200">200</option>
          </select>
        </div>
        <div v-for="(vals, index) in doggys" :key="index" class="dd">
          <img
            :src="vals.imageUrl"
            class="nes-icon is-large"
            style="background: #8e6fb6"
            @click="getDoggyAttributes(vals.nftId)"
          />
          <div class="overlay">{{ vals.nftId }}</div>
        </div>
        <div class="pagination center">
          <a href="#" @click="movePage('backward', curPage)">&laquo;</a>
          <!-- <a href="#" v-for="i in offsets" :key="i" @click="getDoggy(i * 50)">{{
            i
          }}</a> -->
          Page {{ curPage + 1 }}/{{ offsets }}
          <a href="#" @click="movePage('forward', curPage)">&raquo;</a>
        </div>
      </section>
      <a href="/advanced">Try Advanced Search!</a>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import clippy from "clippyjs";
import {
  movePage,
  getToken,
  getNFT,
  getDoggyAttributes,
  getDoggy,
} from "./functions";
import firebase from "firebase";
export default {
  data() {
    return {
      visitor_count: 'Loading...',
      show: true,
      maxPerPage: 50,
      curPage: 0,
      saleCount: "Loading",
      tokensupply: "Loading...",
      nftminted: "Loading...",
      enterID: null,
      dognftid: null,
      dogimg: null,
      dog: {
        breed: "Beagle",
        rare: "No",
        color: "Mixed-Colours",
        accessory: "No",
        "accessory Type": "None",
        "collectible Value": "1",
      },
      offsets: 0,
      doggys: null,
      basicStats: {
        Chihuahua: [
          10,
          "https://d3ggs2vjn5heyw.cloudfront.net/images/doggy/Doggy61.gif",
        ],
        Collie: [
          100,
          "https://d3ggs2vjn5heyw.cloudfront.net/images/doggy/Doggy1223.gif",
        ],
        Bulldog: [
          866,
          "https://d3ggs2vjn5heyw.cloudfront.net/images/doggy/Doggy9988.gif",
        ],
        Huskie: [
          885,
          "https://d3ggs2vjn5heyw.cloudfront.net/images/doggy/Doggy9986.gif",
        ],
        Beagle: [
          902,
          "https://d3ggs2vjn5heyw.cloudfront.net/images/doggy/Doggy9975.gif",
        ],
        "Basset-Hound": [
          906,
          "https://d3ggs2vjn5heyw.cloudfront.net/images/doggy/Doggy9995.gif",
        ],
        Pug: [
          931,
          "https://d3ggs2vjn5heyw.cloudfront.net/images/doggy/Doggy9968.gif",
        ],

        Terrier: [
          953,
          "https://d3ggs2vjn5heyw.cloudfront.net/images/doggy/Doggy9997.gif",
        ],
        "Shih-Tzu": [
          957,
          "https://d3ggs2vjn5heyw.cloudfront.net/images/doggy/Doggy9991.gif",
        ],

        "Shiba-Inu": [
          1651,
          "https://d3ggs2vjn5heyw.cloudfront.net/images/doggy/Doggy9996.gif",
        ],
        "Gold-Retriever": [
          1836,
          "https://d3ggs2vjn5heyw.cloudfront.net/images/doggy/Doggy9987.gif",
        ],
      },
      rarityStats: {
        1: [14, 5],
        2: [8, 22],
        3: [7, 5],
        4: [6, 1098],
        5: [4, 785],
        6: [3, 3320],
        7: [2, 2734],
        8: [1, 2028],
      },
    };
  },
  agent: null,
  mounted() {
    var count = 0;
    const db = firebase.firestore();
    var FieldValue = firebase.firestore.FieldValue;
    const docRef = db.collection("counters").doc("visitors");

    docRef.set({}, { merge: true });

    const incrementAndGetVisitorCount = async () =>
      docRef
        .update({ count: FieldValue.increment(1) })
        .then(() => docRef.get())
        .then((doc) => {
          console.log(doc.data().count);
          this.visitor_count = doc.data().count;
        });
          incrementAndGetVisitorCount()
        
  },
  created() {
    document.title = "Doggy Dex";
    axios
      .get(
        "https://www.bakeryswap.org/api/v2/nfts?nftType=104&offset=0&limit=0&sortName=price&sortBy=asc&onSale=1&status=1&keyword="
      )
      .then((resp) => {
        var x = resp.data.data.list;
        var onsaledict = [];
        //console.log("in Created!");
        //console.log(x[0].attributes);
        x.forEach((x) => {
          onsaledict.push({
            nftid: x.nftId,
            accessory: x.attributes.accessory,
            accessoryType: x.attributes.accessoryType,
            breed: x.attributes.breed,
            collectibleValue: x.attributes.collectibleValue,
            color: x.attributes.color,
            rare: x.attributes.rare,
          });
        });
        //console.log(onsaledict);
      });
    this.getDoggy(0);
    this.getDoggyAttributes(1234);
    setTimeout(() => {
      this.getToken();
    }, 2500);
    setTimeout(() => {
      this.getNFT();
    }, 5000);

    clippy.load("Rocky", (agent) => {
      this.$options.agent = agent;
      // do anything with the loaded agent
      agent.show();
      agent.moveTo(250, 250);
    });
    setTimeout(() => {
      this.$options.agent.speak("Welcome to Doggy Dex!");
    }, 1000);
    setTimeout(() => {
      this.$options.agent.speak("Here's a random Trivia!!");
    }, 2500);
    setTimeout(() => {
      this.$options.agent.speak(
        "There are only 5 Doggys with collectible level 14!"
      );
    }, 5000);
    setTimeout(() => {
      this.$options.agent.hide();
    }, 11000);
  },
  jsondata: {},
  methods: { movePage, getToken, getNFT, getDoggyAttributes, getDoggy },
};
</script>
<style>
.tab {
  width: auto;
  border-width: 4px;
  table-layout: fixed;
}

td {
  padding: 0;
}
.nes-container {
  padding: 1rem 0.25rem;
}
@media screen and (min-width: calc(980px)) {
  #bscaddr {
    font-size: 20px;
  }
  .tab {
    width: 99%;
    white-space: normal;
  }
}
@media screen and (max-width: calc(980px)) {
  #bscaddr {
    font-size: 8px;
  }
}
.pagination {
  align-items: center;
  padding: 5px;
  display: block;
  color: #f6d381;
}

.pagination a {
  margin: auto;
  color: black;
  float: center;
  padding: 40px 4px;
  text-decoration: none;
}

.dd {
  position: relative;
  display: inline-block;
}

.image {
  display: block;
  width: 100%;
  height: auto;
}

.overlay {
  position: absolute;
  bottom: 0;
  background: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.5); /* Black see-through */
  color: #f1f1f1;
  transition: 0.5s ease;
  opacity: 0;
  color: white;
  padding: 2px;
  text-align: center;
}
.dd:hover .overlay {
  opacity: 1;
}
.accordion {
  background-color: #eee;
  padding: 18px;
  width: 95%;
  text-align: center;
  margin-bottom: 18px;
  transition: 0.4s;
}

/* Add a background color to the button if it is clicked on (add the .active class with JS), and when you move the mouse over it (hover) */
.activew,
.accordion:hover {
  background-color: #ccc;
}

/* Style the accordion panel. Note: hidden by default */
.panel {
  padding: 10px 18px;
  display: block;
  overflow: hidden;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

input[type="checkbox"] {
  width: 1.5rem;
  height: 1.5rem;
}
</style>